import React from 'react';
import classNames from 'classnames';
import { Text } from '@ui';
import './SyncHealthBadgeStyles.scss';
const STATE_ICON = {
    healthy: 'fa-solid fa-badge-check',
    attention: 'fa-solid fa-circle-minus'
};
/**
 * Header status badge for the integration sync-status panels. Pairs a Font
 * Awesome icon with a label — a green badge-check for healthy/connected and a
 * red minus-circle for attention — matching the IP-13778 designs. Replaces the
 * plain dot-style Status pill in the panel headers.
 */
export function SyncHealthBadge({ state, label, className }) {
    return (React.createElement("span", { className: classNames('qmb-ui-sync-health-badge', `qmb-ui-sync-health-badge--${state}`, className) },
        React.createElement("i", { className: classNames('sync-health-badge__icon', STATE_ICON[state]), "aria-hidden": "true" }),
        React.createElement(Text, { variant: "label", className: "sync-health-badge__label" }, label)));
}
